import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PersonalDetails from "./Components/ProfileSettings/PersonalDetails";
// import ExperienceEducation from "./Components/ProfileSettings/ExperienceEducation";
import Downloads from "./Components/ProfileSettings/Downloads";
import Registrations from "./Components/ProfileSettings/Registrations";
import Gallery from "./Components/ProfileSettings/Gallery";
import Defaultlocation from "./Components/ProfileSettings/Defaultlocation";
import SocialProfiles from "./Components/ProfileSettings/Socialprofiles";
import { oneKlicks } from "../../../SDK/oneclick";
import { OneKlicksFileSDK } from "../../../SDK/OneKlicksFileSDK";
import { toast } from "react-toastify";
import { getuserdata } from "../../../services/apiService";
import Preloader from "../../../Uitiles/Preloader";

const PharmacyProfileSettings = () => {
    const [userdata, setUserdata] = useState({});
    const { sublink } = useParams();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("Personal Details");
    const [isLoading, setIsLoading] = useState(true);

    // const [educations, setEducations] = useState([]);
    // const [experiences, setExperiences] = useState([]);
    const [awards, setAwards] = useState([]);
    const [downloads, setDownloads] = useState([]);
    const [localRegistrations, setLocalRegistrations] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);

    const [galleryImages, setGalleryImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [newVideoUrl, setNewVideoUrl] = useState("");
    const [galleryid, setGalleryid] = useState([]);

    const [selectedCountry, setSelectedCountry] = useState('india');
    const [selectedCity, setSelectedCity] = useState('');
    const [searchAddress, setSearchAddress] = useState('');
    const [mapCenter, setMapCenter] = useState({ lat: 20.5937, lng: 78.9629 });

    const tabToUrlMapping = {
        "Personal Details": "personal-details",
        // "Experience & Education": "experience-education",
        "Downloads": "awards-downloads",
        "Registrations": "registrations",
        "Gallery": "gallery",
        "Default location": "default-location",
        "Social profiles": "social-profiles"
    };

    useEffect(() => {
        const tabMapping = {
            // "experience-education": "Experience & Education",
            "awards-downloads": "Downloads",
            "registrations": "Registrations",
            "gallery": "Gallery",
            "default-location": "Default location",
            "social-profiles": "Social profiles",
            "personal-details": "Personal Details",
            // Back-compat for old link label
            "pharmacy-details": "Personal Details"
        };
        if (sublink && tabMapping[sublink]) {
            setActiveTab(tabMapping[sublink]);
        } else {
            setActiveTab("Personal Details");
        }
    }, [sublink]);

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        const urlPath = tabToUrlMapping[tabName];
        if (urlPath) {
            navigate(`/pharmacy/profilesettings/${urlPath}`);
        }
    };

    const [personalDetailsFormData, setPersonalDetailsFormdata] = useState({
        name: "",
        gendar: "",
        subheading: "",
        first_name: "",
        last_name: "",
        display_name: "",
        starting_price: "",
        mobile_number: "",
        description: "",
        languages: [],
        profile_photo: null,
        profile_photo_url: null,
        profile_banner: null,
        profile_banner_url: null,
        memberships: [],
    });

    const [socialProfiles, setSocialProfiles] = useState({
        facebook: "",
        twitter: "",
        linkedin: "",
        skype: "",
        pinterest: "",
        tumblr: "",
        instagram: "",
        flickr: "",
        medium: "",
        tripadvisor: "",
        wikipedia: "",
        vimeo: "",
        youtube: "",
        whatsapp: "",
        vkontakte: "",
        odnoklassniki: ""
    });
    const [socialloading, setSocialLoading] = useState(true);

    useEffect(() => {
        bootstrapLoad();
    }, []);

    const bootstrapLoad = async () => {
        try {
            setIsLoading(true);
            await Promise.all([
                getAllUserData(),
                // getAllExperienceEducation(),
                getAllRegistrations(),
                getAllAwardsDownloads(),
                getAllGallery(),
                getAllDefaultLocation(),
                getAllSocialProfiles()
            ]);
        } catch (e) {
            // no-op; individual functions toast/log
        } finally {
            setIsLoading(false);
        }
    };

    const getAllSocialProfiles = async () => {
        setSocialLoading(true);
        try {
            const res = await oneKlicks.read("", "pharmacy_social_profiles", { user_id: await getuserdata("id") }, "", "", "", "");
            if (res.success === true && res.data.length > 0) {
                setSocialProfiles(res.data[0].social_profiles);
            }
        } catch (error) {
            // silent
        } finally {
            setSocialLoading(false);
        }
    };

    const getAllDefaultLocation = async () => {
        try {
            const user_id = await getuserdata("id");
            const res = await oneKlicks.read("", "pharmacies_location", { pharmacies_id: user_id }, "", "", "", "");
            if (res.success === true && res.data.length > 0) {
                const locData = res.data[0];
                setSelectedCountry(locData.country || 'india');
                setSelectedCity(locData.city || '');
                setSearchAddress(locData.address || '');
                setMapCenter({
                    lat: Number(locData.lat) || 20.5937,
                    lng: Number(locData.lng) || 78.9629
                });
            }
        } catch (error) {
            console.error('Error fetching location:', error);
        }
    };

    const getAllGallery = async () => {
        try {
            const res = await oneKlicks.read("", "pharmacy_gallery", { user_id: await getuserdata("id") }, "", "", "", "");
            if (res.success === true && res.data.length > 0) {
                setGalleryImages(res.data[0].images);
                setVideos(res.data[0].videos);
                setGalleryid(res.data[0].id);
            }
        } catch (error) {
            // silent
        }
    };

    const getAllAwardsDownloads = async () => {
        try {
            const res = await oneKlicks.read("", "pharmacy_awards_downloads", { user_id: await getuserdata("id") }, "", "", "", "");
            if (res.success === true && res.data.length > 0) {
                setAwards(res.data[0].awards);
                setDownloads(res.data[0].downloads);
            }
        } catch (error) {
            // silent
        }
    };

    const getAllRegistrations = async () => {
        try {
            const res = await oneKlicks.read("", "pharmacy_registrations", { user_id: await getuserdata("id") }, "", "", "", "");
            if (res.success === true && res.data.length > 0) {
                setLocalRegistrations(res.data[0].registrations);
            }
        } catch (error) {
            // silent
        }
    };

    // const getAllExperienceEducation = async () => {
    //     try {
    //         const res = await oneKlicks.read("", "pharmacy_experience_education", { user_id: await getuserdata("id") }, "", "", "", "");
    //         if (res.success === true && res.data.length > 0) {
    //             setEducations(res.data[0].educations);
    //             setExperiences(res.data[0].experiences);
    //         }
    //     } catch (error) {
    //         // silent
    //     }
    // };

    const getAllUserData = async () => {
        try {
            const fullUserData = await getuserdata("full");
            const user_id = fullUserData?.id;
            const user_type = fullUserData?.user_type;

            let tableName = "users";
            if (user_type === "pharmacy") tableName = "pharmacies";
            else if (user_type === "blood_bank") tableName = "blood_bank";
            else if (user_type === "diagnostic") tableName = "diagnostics";
            else if (user_type === "ambulance") tableName = "ambulances";

            const res = await oneKlicks.read("", tableName, { id: user_id }, "", "", "", "");

            if (res.success === true && res.data.length > 0) {
                const userData = res.data[0];
                setUserdata(userData);
                let languages = userData.languages;
                let memberships = userData.memberships;
                if (typeof languages === 'string') {
                    try { languages = JSON.parse(languages); } catch (e) { languages = []; }
                }
                if (typeof memberships === 'string') {
                    try { memberships = JSON.parse(memberships); } catch (e) { memberships = []; }
                }

                // Map database columns to form state
                // Note: specialized tables use 'photourl' and 'name' often
                setPersonalDetailsFormdata({
                    name: userData.name || userData.display_name || "",
                    email: userData.email || "",
                    gendar: userData.gendar || "",
                    subheading: userData.subheading || "",
                    first_name: userData.first_name || "",
                    last_name: userData.last_name || "",
                    display_name: userData.display_name || userData.name || "",
                    starting_price: userData.starting_price || "",
                    mobile_number: userData.phone || "",
                    description: userData.description || "",
                    languages: languages || [],
                    profile_photo: userData.profile_photo || userData.photoid || null,
                    profile_photo_url: userData.profile_photo_url || userData.photourl || null, // Map photourl to profile_photo_url
                    profile_banner: userData.profile_banner || null,
                    profile_banner_url: userData.profile_banner_url || null,
                    memberships: memberships || [],
                });
            }
        } catch (error) {
            console.error("Error fetching user data", error);
            toast.error('Failed to fetch user data');
        }
    };

    const submitPersonalDetails = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const fullUserData = await getuserdata("full");
            const user_id = fullUserData?.id;
            const user_type = fullUserData?.user_type;

            let tableName = "users";
            if (user_type === "pharmacy") tableName = "pharmacies";
            else if (user_type === "blood_bank") tableName = "blood_bank";
            else if (user_type === "diagnostic") tableName = "diagnostics";
            else if (user_type === "ambulance") tableName = "ambulances";

            const data = {
                gendar: personalDetailsFormData.gendar,
                subheading: personalDetailsFormData.subheading,
                first_name: personalDetailsFormData.first_name,
                last_name: personalDetailsFormData.last_name,
                display_name: personalDetailsFormData.display_name,
                starting_price: personalDetailsFormData.starting_price,
                phone: personalDetailsFormData.mobile_number,
                description: personalDetailsFormData.description,
                languages: JSON.stringify(personalDetailsFormData.languages),

                // Map back to correct columns for specialized tables if needed
                ...(tableName === "pharmacies" || tableName === "blood_bank" || tableName === "diagnostics" || tableName === "ambulances" ? {
                    name: personalDetailsFormData.display_name, // Specialized tables usually use 'name' as primary display
                    photourl: personalDetailsFormData.profile_photo_url,
                    photoid: personalDetailsFormData.profile_photo
                } : {
                    profile_photo: personalDetailsFormData.profile_photo,
                    profile_photo_url: personalDetailsFormData.profile_photo_url,
                }),

                profile_banner: personalDetailsFormData.profile_banner,
                profile_banner_url: personalDetailsFormData.profile_banner_url,
                memberships: JSON.stringify(personalDetailsFormData.memberships),
            };

            const updateRes = await oneKlicks.update("", tableName, data, { id: user_id });
            if (!updateRes.success) {
                throw new Error(updateRes.error || "Failed to update profile");
            }
            toast.success("Profile updated successfully", { autoClose: 2000 });
            await getAllUserData();
        } catch (err) {
            toast.error(err.message || "An unexpected error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    // const submitExperienceEducation = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);
    //     try {
    //         const data = {
    //             user_id: await getuserdata("id"),
    //             educations: JSON.stringify(educations),
    //             experiences: JSON.stringify(experiences)
    //         };
    //         const updateRes = await oneKlicks.update("", "pharmacy_experience_education", data, { user_id: await getuserdata("id") });
    //         if (!updateRes.success) throw new Error(updateRes.error || "Failed to update experience and education");
    //         toast.success("Experience and Education updated successfully", { autoClose: 2000 });
    //     } catch (err) {
    //         toast.error(err.message || "An unexpected error occurred");
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const submitAwardsDownloads = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const data = {
                user_id: await getuserdata("id"),
                awards: JSON.stringify(awards),
                downloads: JSON.stringify(downloads)
            };
            const updateRes = await oneKlicks.update("", "pharmacy_awards_downloads", data, { user_id: await getuserdata("id") });
            if (!updateRes.success) throw new Error(updateRes.error || "Failed to update awards and downloads");
            toast.success("Awards and Downloads updated successfully", { autoClose: 2000 });
        } catch (err) {
            toast.error(err.message || "An unexpected error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    const saveRegistrations = async (updatedRegistrations) => {
        setIsSaving(true);
        try {
            const data = {
                user_id: await getuserdata("id"),
                registrations: JSON.stringify(updatedRegistrations)
            };
            const updateRes = await oneKlicks.update("", "pharmacy_registrations", data, { user_id: await getuserdata("id") });
            if (!updateRes.success) throw new Error(updateRes.error || "Failed to save registrations");
            setHasChanges(false);
            return true;
        } catch (error) {
            toast.error(error.message || "Failed to save registrations");
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    const submitRegistrations = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!hasChanges) { setIsLoading(false); return; }
        const success = await saveRegistrations(localRegistrations);
        if (success) toast.success("Registrations updated successfully");
        setIsLoading(false);
    };

    const saveGallery = async (images, vids) => {
        try {
            const data = {
                user_id: await getuserdata("id"),
                images: JSON.stringify(images),
                videos: JSON.stringify(vids)
            };
            const updateRes = await oneKlicks.update("", "pharmacy_gallery", data, { user_id: await getuserdata("id") });
            if (!updateRes.success) throw new Error(updateRes.error || "Failed to save gallery");
            return true;
        } catch (error) {
            return false;
        }
    };

    const submitGallery = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const ok = await saveGallery(galleryImages, videos);
        if (ok) toast.success("Gallery updated successfully");
        setIsLoading(false);
    };

    const saveDefaultLocation = async (country, city, address, center) => {
        try {
            const user_id = await getuserdata("id");
            const res = await oneKlicks.read("", "pharmacies_location", { pharmacies_id: user_id }, "", "", "", "");

            const payload = {
                pharmacies_id: user_id,
                country: country,
                city: city,
                address: address,
                lat: center.lat.toString(),
                lng: center.lng.toString(),
            };

            let updateRes;
            if (res.success && res.data.length > 0) {
                updateRes = await oneKlicks.update("", "pharmacies_location", payload, { pharmacies_id: user_id });
            } else {
                updateRes = await oneKlicks.create("", "pharmacies_location", payload);
            }

            if (!updateRes.success) throw new Error(updateRes.error || "Failed to save default location");
            return true;
        } catch (error) {
            console.error('Error saving location:', error);
            return false;
        }
    };

    const submitDefaultLocation = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const ok = await saveDefaultLocation(selectedCountry, selectedCity, searchAddress, mapCenter);
        if (ok) toast.success("Default location updated successfully");
        setIsLoading(false);
    };

    const saveSocialProfiles = async (profiles) => {
        try {
            const data = {
                user_id: await getuserdata("id"),
                social_profiles: JSON.stringify(profiles)
            };
            const updateRes = await oneKlicks.update("", "pharmacy_social_profiles", data, { user_id: await getuserdata("id") });
            if (!updateRes.success) throw new Error(updateRes.error || "Failed to save social profiles");
            return true;
        } catch (error) {
            return false;
        }
    };

    const submitSocialProfiles = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const ok = await saveSocialProfiles(socialProfiles);
        if (ok) toast.success("Social profiles updated successfully");
        setIsLoading(false);
    };

    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {isLoading ? (
                    <Preloader />
                ) : (
                    <>
                        <section className="dc-haslayout dc-dbsectionspace">
                            <div className="row">
                                <div className={`col-xs-12 col-sm-12 col-md-12  ${activeTab == "Gallery" ? "col-lg-12 col-xl-12" : "col-lg-8 col-xl-9"}`}>
                                    <form className="dc-user-profile" method="post">
                                        <div className="dc-dashboardbox dc-dashboardtabsholder">
                                            <div className="dc-dashboardboxtitle" style={{ display: window.innerWidth < 576 ? 'none' : 'block' }}>
                                                <h2>{activeTab}</h2>
                                            </div>
                                            <div className="dc-dashboardtabs" style={{ display: 'block' }}>
                                                <ul className="dc-tabstitle nav navbar-nav">
                                                    <li className="nav-item"><a className={`${activeTab == "Personal Details" ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Personal Details"); }}>Personal Details</a></li>
                                                    {/* <li className="nav-item"><a className={`${activeTab == "Experience & Education" ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Experience & Education"); }}>Experience &amp; Education</a></li> */}
                                                    <li className="nav-item"><a className={`${activeTab == "Downloads" ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Downloads"); }}>Downloads</a></li>
                                                    <li className="nav-item"><a className={`${activeTab == "Registrations" ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Registrations"); }}>Registrations</a></li>
                                                    <li className="nav-item"><a className={`${activeTab == "Gallery" ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Gallery"); }}>Gallery</a></li>
                                                    <li className="nav-item"><a className={`${activeTab == "Default location" ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Default location"); }}>Default location</a></li>
                                                    <li className="nav-item"><a className={`${activeTab == "Social profiles" ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); handleTabClick("Social profiles"); }}>Social profiles</a></li>
                                                </ul>
                                            </div>

                                            {activeTab == "Personal Details" && (
                                                <PersonalDetails PersonalDetailsformdata={personalDetailsFormData} setPersonalDetailsFormdata={setPersonalDetailsFormdata} />
                                            )}
                                            {/* {activeTab == "Experience & Education" && (
                                                <ExperienceEducation educations={educations} setEducations={setEducations} experiences={experiences} setExperiences={setExperiences} />
                                            )} */}
                                            {activeTab == "Downloads" && (
                                                <Downloads downloads={downloads} setDownloads={setDownloads} />
                                            )}
                                            {activeTab == "Registrations" && (
                                                <Registrations localRegistrations={localRegistrations} setLocalRegistrations={setLocalRegistrations} isUploading={isUploading} setIsUploading={setIsUploading} isSaving={isSaving} setIsSaving={setIsSaving} hasChanges={hasChanges} setHasChanges={setHasChanges} />
                                            )}
                                            {activeTab == "Gallery" && (
                                                <Gallery galleryImages={galleryImages} setGalleryImages={setGalleryImages} videos={videos} setVideos={setVideos} newVideoUrl={newVideoUrl} setNewVideoUrl={setNewVideoUrl} isUploading={isUploading} setIsUploading={setIsUploading} galleryid={galleryid} />
                                            )}
                                            {activeTab == "Default location" && (
                                                <Defaultlocation
                                                    selectedCountry={selectedCountry}
                                                    setSelectedCountry={setSelectedCountry}
                                                    selectedCity={selectedCity}
                                                    setSelectedCity={setSelectedCity}
                                                    searchAddress={searchAddress}
                                                    setSearchAddress={setSearchAddress}
                                                    mapCenter={mapCenter}
                                                    setMapCenter={setMapCenter}
                                                    userdata={userdata}
                                                />
                                            )}
                                            {activeTab == "Social profiles" && (
                                                <SocialProfiles socialProfiles={socialProfiles} setSocialProfiles={setSocialProfiles} socialloading={socialloading} setSocialLoading={setSocialLoading} />
                                            )}
                                        </div>
                                        <div className="dc-updatall">
                                            <i className="ti-announcement"></i>
                                            <span>Update all the latest changes made by you, by just clicking on Save &amp; Update button.</span>
                                            <a className="dc-btn dc-update-profile-doctorss" href="#" onClick={(e) => {
                                                e.preventDefault();
                                                if (activeTab === "Personal Details") {
                                                    submitPersonalDetails(e);
                                                    // } else if (activeTab === "Experience & Education") {
                                                    //     submitExperienceEducation(e);
                                                } else if (activeTab === "Downloads") {
                                                    submitAwardsDownloads(e);
                                                } else if (activeTab === "Registrations") {
                                                    submitRegistrations(e);
                                                } else if (activeTab === "Gallery") {
                                                    submitGallery(e);
                                                } else if (activeTab === "Default location") {
                                                    submitDefaultLocation(e);
                                                } else if (activeTab === "Social profiles") {
                                                    submitSocialProfiles(e);
                                                }
                                            }}>Save &amp; Update</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </>
                )}
            </div>
        </>
    );
};

export default PharmacyProfileSettings;


